module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxMycgaGVpZ2h0PSc4JyB2aWV3Qm94PScwIDAgMTMgOCc+PHBvbHlnb24gZmlsbD0ncmdiYSgwLCAwLCAwLCAwLjYpJyBwb2ludHM9JzYuNTExIDcuMzcxIDAgMC43MTUgMC43MzEgMCA2LjUxIDUuOTA3IDEyLjI2NyAwIDEzIDAuNzE0IDYuNTExIDcuMzcxJy8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/images/img-down-arrow.svg
// module id = IHFP
// module chunks = 1